import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './MobileTabs.scss';
import ProfileIcon from './icons/ProfileIcon';
import PackagesIcon from './icons/PackagesIcon';
import CalendarIcon from './icons/CalendarIcon';
import EncounterIcon from './icons/EncountersIcon';

export const TABS = {
    packages: 'packages',
    encounters: 'encounters',
    calendar: 'calendar',
    profile: 'profile'
};

export default class MobileTabs extends PureComponent {
    static propTypes = {
        activeTab: PropTypes.oneOf(Object.values(TABS)),
        currentUser: PropTypes.object,
    };

    static defaultProps = {
        activeTab: 'doctor'
    };

    render() {
        const {currentUser} = this.props;

        return (
            <nav className={styles.wrapper}>
                <button
                    onClick={() => this.handleClick(TABS.profile)}
                    className={styles.tab}
                >
                    <ProfileIcon
                        className={
                            classnames(styles.icon, this.isActive(TABS.profile))
                        }
                    />
                </button>
                <button
                    onClick={() => this.handleClick(TABS.packages)}
                    className={styles.tab}
                >
                    <PackagesIcon
                        className={
                            classnames(styles.icon, this.isActive(TABS.packages))
                        }
                    />
                </button>
                {currentUser.subscription && currentUser.subscription.isActive && (
                    <button
                        onClick={() => this.handleClick(TABS.calendar)}
                        className={styles.tab}
                    >
                        <CalendarIcon
                            className={
                                classnames(styles.icon, this.isActive(TABS.calendar))
                            }
                        />
                    </button>
                )}
                <button
                    onClick={() => this.handleClick(TABS.encounters)}
                    className={styles.tab}
                >
                    <EncounterIcon
                        className={
                            classnames(styles.icon, this.isActive(TABS.encounters))
                        }
                    />
                </button>
            </nav>
        );
    }

    handleClick = (tab) => {
        const {onChangeTab} = this.props;
        onChangeTab(tab);
    };

    isActive = (tab) => {
        const {activeTab} = this.props;
        return {[styles.active]: tab === activeTab};
    };
}



// WEBPACK FOOTER //
// ./src/components/controls/MobileTabs.js